<template>
  <div class="screen-wrapper">
    <div class="screen" id="screen">
      <div class="header">
        <div>农场外塘概况</div>
        <div>Enterprise Cloud Service Platform</div>
      </div>
      <div class="operation">
        <div>
          <el-select v-model="requestParams.baseId" placeholder="请选择" @change="getPongAllView">
            <template v-for="item in baseList">
              <el-option :label="item.value" :value="item.key" :key="item.key" />
            </template>
          </el-select>
        </div>
        <div class="pond">
          <div>共 {{pondListTotal}} 个鱼塘</div>
          <div @click="$refs.addPondDialogRef.add()">新增鱼塘</div>
        </div>
      </div>
      <div class="content">
        <template v-for="item in pondList">
          <pond-info-card :data="item" :key="item.name" />
        </template>
      </div>
      <el-pagination layout="prev, pager, next" @current-change="getPongAllView" :page-size="15"
        :current-page.sync="requestParams.PageIndex" :total="pondListTotal" class="pagination"
      />
    </div>
    <add-pond-dialog ref="addPondDialogRef" @getPongAllView="getPongAllView"/>
  </div>
</template>

<script>
import PondInfoCard from './components/PondInfoCard'
import AddPondDialog from './components/AddPondDialog'
import { getBaseKeyValue, getPongAllView } from "@/service/apiData.js"
import { Loading } from 'element-ui'

export default {
  name: 'farmMonitoring',
  components: {
    'pond-info-card': PondInfoCard,
    'add-pond-dialog': AddPondDialog,
  },
  data () {
    return {
      baseList: [],
      requestParams: {
        baseId: '',
        PageIndex: 1,
        PageSize: 15
      },
      pondListTotal: 0,
      pondList: []
    }
  },
  computed: {},
  methods: {
    async getBaseKeyValue(){
      const { data: baseList } = await getBaseKeyValue();
      baseList.unshift({key: '', value: `全部基地（${baseList.length}）`})
      this.baseList = baseList;
      this.getPongAllView();
    },
    async getPongAllView(){
      const { data: pondListRes } = await getPongAllView(this.requestParams);
      pondListRes.list.forEach( item => {
        item.fishDensity = item.fishDensity.toFixed(2)
        item.fishFeed = item.fishFeed.toFixed(2)
      });
      this.pondList = pondListRes.list
      this.pondListTotal = pondListRes.total
    },
    handleCurrentChange(){

    },
    handleScreenAuto () {
      const designDraftWidth = 1920 // 设计稿的宽度
      const designDraftHeight = 936 // 设计稿的高度
      // 根据屏幕的变化适配的比例
      const scale =
        document.documentElement.clientWidth /
          document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight
      // 缩放比例
      document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`
    }
  },
  mounted () {
    this.handleScreenAuto()
    window.onresize = () => this.handleScreenAuto()

    this.getBaseKeyValue()
  },
  deleted () {
    window.onresize = null
  }
}
</script>
<style scoped lang="stylus">
.screen-wrapper {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  repeat: no-repeat;
  background-color: #F2F3F9;
  .screen {
    display: inline-block;
    width: 1920px;
    height: 936px;
    transform-origin: 0 0;
    position: absolute;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header{
      width: 100%;
      height: 119px;
      background-image: url(./images/topbg.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      div:nth-child(1){
        font-size: 48px;
        font-weight: bold;
        color: #001133;
      }
      div:nth-child(2){
        font-size: 12px;
        color: #001133;
      }
    }
    .operation{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 68px;
      box-sizing: border-box;
      transform: translateY(-30px);
      .pond{
        display: flex;
        align-items: center;
        div:nth-child(1){
          font-size: 18px;
          color: #333333;
          margin-right: 24px;
        }
        div:nth-child(2){
          width: 120px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          background: #0077FF;
          border: 1px solid #74C2FF;
          border-radius: 4px;
          font-size: 20px;
          color: #FFF;
          cursor: pointer;
        }
      }
    }
    .content{
      width: 100%;
      flex: 1;
      padding: 0 68px;
      box-sizing: border-box;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      // flex-wrap: wrap;

      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr;
      column-gap: 10px;
      row-gap: 10px;
    }
    .pagination{
      margin-bottom: 20px;
    }
  }
}
</style>
